<template>
    <v-card class="mt-4">
        <v-card-title>
            <v-row align="center">
                <v-col class="grow ma-2">Data Collection Tasks</v-col>
                <v-spacer />
                <v-col class="shrink text-right">
                    <v-btn
                        color="primary"
                        class="ma-2"
                        @click="showCreateDataCollectionTaskFromTaskGroupForm"
                    >
                        Create from Task Groups
                    </v-btn>
                    <v-btn color="primary" class="ma-2" @click="showCreateDataCollectionTaskForm">
                        New Data Collection Task
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-title>
        <data-collection-task-data-table
            :show-edit-buttons="true"
            :show-measurements-buttons="false"
            :show-template-download="false"
            :show-filters-panel="false"
            :experiment="experiment"
            :protocol="protocol"
            :task-groups="taskGroups"
            :readout-groups="readoutGroups"
            :data-collection-tasks="dataCollectionTasks"
            @showEditDataCollectionTaskFilter="showEditTaskFilter"
            @showEditDataCollectionTask="showEditDataCollectionTask"
            @deleteDataCollectionTask="deleteDataCollectionTask"
        />
        <v-dialog v-model="showDataCollectionTasksFromTaskGroupsForm" width="1000" persistent>
            <data-collection-task-from-task-groups-form
                :readout-groups="readoutGroups"
                :task-groups="taskGroups"
                :experiment="experiment"
                :protocol="protocol"
                ref="dataCollectionTasksFromTaskGroupsForm"
                @closed="dataCollectionTasksFromTaskGroupsFormClosed"
                @saved="dataCollectionTasksFromTaskGroupsSaved"
            />
        </v-dialog>
        <v-dialog v-model="showDataCollectionTaskForm" width="1000" persistent>
            <data-collection-task-form
                v-if="showDataCollectionTaskForm && selectedDataCollectionTask !== null"
                :readout-groups="readoutGroups"
                :task-groups="taskGroups"
                :experiment="experiment"
                :data-collection-task="selectedDataCollectionTask"
                @closed="dataCollectionTaskFormClosed"
                @saved="dataCollectionTaskSaved"
            />
        </v-dialog>
        <v-dialog v-model="showTaskFiltersForm" width="1000" persistent>
            <edit-filters-form
                v-if="showTaskFiltersForm && selectedDataCollectionTask !== null"
                :data-collection-task="selectedDataCollectionTask"
                :task-groups="taskGroups"
                :readout-groups="readoutGroups"
                :experiment="experiment"
                :protocol="protocol"
                @closed="taskFilterFormClosed"
                @saved="filterSaved"
            />
        </v-dialog>
    </v-card>
</template>
<script>
import DataCollectionTaskForm from "./DataCollectionTaskForm.vue";
import { buildDataCollectionTasksAPIForExperiment } from "@/services/api.services.ts";
import { EventBus } from "@/lib/event-bus.js";
import DataCollectionTaskDataTable from "./DataCollectionTaskDataTable.vue";
import DataCollectionTaskFromTaskGroupsForm from "./DataCollectionTasksFromTaskGroupsForm.vue";
import { nextTick, defineComponent } from "vue";
import EditFiltersForm from "./TaskFilterForm.vue";

export default defineComponent({
    name: "data-collection-task-list",

    components: {
        EditFiltersForm,
        DataCollectionTaskFromTaskGroupsForm,
        DataCollectionTaskDataTable,
        DataCollectionTaskForm,
    },

    props: {
        dataCollectionTasks: {
            type: Array,
            required: true,
        },
        readoutGroups: {
            type: Array,
            required: true,
        },
        taskGroups: {
            type: Array,
            required: true,
        },
        experiment: {
            type: Object,
            required: true,
        },
        protocol: {
            type: Object, // AbstractSchemaConfig
            required: true,
        },
    },

    data() {
        return {
            dataCollectionTasksAPI: null,
            showDataCollectionTasksFromTaskGroupsForm: false,
            selectedDataCollectionTask: null,
            readoutGroupForSelectedTask: null,
            showDataCollectionTaskForm: false,
            showTaskFiltersForm: false,
        };
    },

    mounted() {
        this.dataCollectionTasksAPI = buildDataCollectionTasksAPIForExperiment(
            this.experiment.code
        );
    },

    methods: {
        showCreateDataCollectionTaskFromTaskGroupForm() {
            this.showDataCollectionTasksFromTaskGroupsForm = true;
            nextTick(() => {
                // $refs.taskGroupFromReferencesForm isn't available until the v-dialog renders it
                // after the boolean toggle is set.
                this.$refs.dataCollectionTasksFromTaskGroupsForm.updated();
            });
        },
        dataCollectionTasksFromTaskGroupsFormClosed() {
            this.showDataCollectionTasksFromTaskGroupsForm = false;
        },
        showCreateDataCollectionTaskForm() {
            this.selectedDataCollectionTask = {
                day: null,
                type: "scheduled",
                readoutGroupId: null,
                taskGroupId: null,
            };
            this.showDataCollectionTaskForm = true;
        },
        showEditTaskFilter(dataCollectionTask) {
            this.selectedDataCollectionTask = dataCollectionTask;
            this.showTaskFiltersForm = true;
        },
        taskFilterFormClosed() {
            this.showTaskFiltersForm = false;
        },
        filterSaved(dataCollectionTask) {
            this.showTaskFiltersForm = false;
            this.$emit("saved", dataCollectionTask);
        },
        showEditDataCollectionTask(dataCollectionTask) {
            this.selectedDataCollectionTask = dataCollectionTask;
            this.showDataCollectionTaskForm = true;
        },
        dataCollectionTaskFormClosed() {
            this.resetDataCollectionTaskForm();
        },
        dataCollectionTasksFromTaskGroupsSaved(dataCollectionTasks) {
            this.showDataCollectionTasksFromTaskGroupsForm = false;
            this.$emit("saved", dataCollectionTasks);
        },
        dataCollectionTaskSaved(dataCollectionTask) {
            this.resetDataCollectionTaskForm();
            this.$emit("saved", dataCollectionTask);
        },
        resetDataCollectionTaskForm() {
            this.selectedDataCollectionTask = null;
            this.showDataCollectionTaskForm = false;
        },
        deleteDataCollectionTask(dataCollectionTask) {
            if (confirm("Are you sure you want to delete this task?")) {
                this.dataCollectionTasksAPI
                    .delete(dataCollectionTask.id)
                    .then(() => {
                        this.$emit("deleted", dataCollectionTask);
                    })
                    .catch((err) => {
                        EventBus.$emit("globalAlert", err);
                    });
            }
        },
    },
});
</script>
<style></style>
